// extracted by mini-css-extract-plugin
export default {"path":"ReplaceIcon_path__Jb7fg"};